import PropTypes from 'prop-types'
import { colors } from '@lmc/common/constants'
import { DefaultLmc, Popover, Text } from '@lmc/ui-kit'
import { history } from '../../../../../store'

const FuturePlansPopup = ({ contingencyPlans, residentId, allowRedirect = true }) => {
  const resolvedResidentId =
    typeof residentId === 'string' ? residentId : residentId?.id

  return (
    <Popover
      content={
        <div style={{ cursor: 'pointer' }}>
          {contingencyPlans.map((plan) => (
            <button
              type="button"
              key={plan.id}
              style={styles.futurePlansPopoverItem}
              onClick={(e) => {
                e.stopPropagation()
                if (allowRedirect && resolvedResidentId) {
                  history.push(
                    `/residents/${resolvedResidentId}/future-plans/${plan.id}`
                  )
                }
              }}
            >
              <DefaultLmc />
              {plan.name}
            </button>
          ))}
        </div>
      }
      placement="bottomRight"
    >
      <div>
        <Text as="p2" style={styles.attachmentsDot}>
          •
        </Text>
        <Text as="p2" style={styles.attachmentsLinkText}>
          {`In ${contingencyPlans.length} ${
            contingencyPlans.length === 1 ? 'Future Plan' : 'Future Plans'
          }`}
        </Text>
      </div>
    </Popover>
  )
}

const styles = {
  attachmentsDot: { marginLeft: 5, color: colors.darkgrey },
  attachmentsLinkText: {
    marginLeft: 5,
    color: colors.informationblue,
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  futurePlansPopoverItem: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 5,
    marginBottom: 5,
    gap: 6,
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: 0
  }
}

FuturePlansPopup.propTypes = {
  contingencyPlans: PropTypes.array.isRequired,
  residentId: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  allowRedirect: PropTypes.bool
}

export default FuturePlansPopup
